import HomeIcon from '@mui/icons-material/Home';
import {
  Add as AddIcon,
  BarChart as BarChartIcon,
  Login as LoginIcon,
  Logout as LogoutIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import React from 'react';
import HzTheme from '../../../theme/HzTheme';
import { TFunction } from 'i18next';

export type IMainNavLinkItems = {
  name: string;
  location: string;
  listIcon: React.JSX.Element;
  roleRequired?: string;
  icon?: React.JSX.Element;
};

export const Pages = (t: TFunction<'translation', undefined>): IMainNavLinkItems[] => [
  {
    name: t('home'),
    location: '/home',
    icon: <HomeIcon fontSize="small" />,
    listIcon: (
      <HomeIcon
        strokeWidth={2}
        sx={{ color: HzTheme.palette.secondary.main }}
      />
    ),
  },
  {
    name: t('reservation'),
    location: '/reservation',
    roleRequired: 'write_reservation',
    listIcon: (
      <AddIcon strokeWidth={2} sx={{ color: HzTheme.palette.secondary.main }} />
    ),
  },
  {
    name: t('check_out'),
    location: '/checkout',
    roleRequired: 'checkout',
    listIcon: (
      <LogoutIcon
        strokeWidth={1}
        sx={{ color: HzTheme.palette.secondary.main }}
      />
    ),
  },
  {
    name: t('check_in'),
    location: '/checkin',
    roleRequired: 'checkin',
    listIcon: (
      <LoginIcon
        strokeWidth={1}
        sx={{ color: HzTheme.palette.secondary.main }}
      />
    ),
  },
  {
    name: t('manage'),
    location: '/manage',
    roleRequired: 'read_reservation',
    listIcon: (
      <SettingsIcon
        strokeWidth={0}
        sx={{ color: HzTheme.palette.secondary.main }}
      />
    ),
  },
  {
    name: t('statistics2'),
    location: '/statistics',
    roleRequired: 'statistics',
    listIcon: (
      <BarChartIcon
        strokeWidth={0}
        sx={{ color: HzTheme.palette.secondary.main }}
      />
    ),
  },
];
